import useAuthState from './useAuthState';
import useAuthTimer from './useAuthTimer';
import useIsCustomer from './useIsCustomer';

export {useIsCustomer, useAuthTimer};
export default useAuthState;
